/**
 * Página de gerenciar protocolos usando TemplateManager em modo página (sem Dialog).
 * Usada quando !defaultApp: gestão fora do atendimento. Requer VetAttendanceProvider
 * para TemplateEditor (edição) usar as sections.
 */

import { useNavigate } from "react-router-dom";
import { VetAttendanceProvider } from "@/fluxvet/contexts/VetAttendanceContext";
import { TemplateManager } from "@/fluxvet/pages/vetattendence/components/TemplateManager";
import { LargeContentBox } from "../../components/common";

export function TemplateManagerPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/protocolsettings");
  };

  return (
    <VetAttendanceProvider>
      <LargeContentBox>
        <TemplateManager asPage onClose={handleBack} />
      </LargeContentBox>
    </VetAttendanceProvider>
  );
}
